import { eur, dateIt } from "@/lib/format";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import ClientEnrollmentStatus from "@/components/app/ClientEnrollmentStatus";
import { GraduationCap } from "lucide-react";

const Field = ({ label, value, mono }) => (
  <div>
    <div className="text-xs uppercase tracking-widest text-slate-500 font-bold">{label}</div>
    <div className={`mt-1 text-sm text-slate-900 ${mono ? "font-mono" : ""}`}>{value || <span className="text-slate-400">—</span>}</div>
  </div>
);

export default function ClientEnrollmentDetail({ item, onClose }) {
  const d = item;
  return (
    <Dialog open={!!d} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="client-enr-detail-dialog">
        <DialogHeader><DialogTitle>Scheda iscritto · {d?.first_name} {d?.last_name}</DialogTitle></DialogHeader>
        {d && (
          <div className="space-y-6">
            <div className="flex items-center gap-2"><ClientEnrollmentStatus status={d.status} />{d.profiled && <Badge className="bg-sky-100 text-sky-800 hover:bg-sky-100">Profilato</Badge>}</div>
            <div className="grid grid-cols-2 gap-4">
              <Field label="Numero iscrizione" value={d.enrollment_number} mono />
              <Field label="Cliente" value={d.client_name} />
              <Field label="Corso" value={d.course_title} />
              <Field label="Edizione" value={d.edition_label} />
              <Field label="Modalità cliente" value={d.billing_mode === "slot" ? "Slot prepagati" : "Fatturazione mensile"} />
              <Field label="Prezzo" value={`${eur(d.unit_price)} ${Number(d.vat_rate) === 0 ? "· Esente IVA" : `+ IVA ${d.vat_rate}%`}`} />
              <Field label="Nome" value={d.first_name} />
              <Field label="Cognome" value={d.last_name} />
              <Field label="Codice fiscale" value={d.fiscal_code} mono />
              <Field label="Data di nascita" value={d.birth_date ? dateIt(d.birth_date) : ""} />
              <Field label="Luogo di nascita" value={d.birth_place} />
              <Field label="Email" value={d.email} />
              <Field label="Telefono" value={d.phone} />
              <Field label="Azienda" value={d.company} />
              <Field label="Mansione" value={d.role} />
              <Field label="Data iscrizione" value={dateIt(d.created_at)} />
              <Field label="Inserita da" value={d.created_by} />
              {d.status === "annullata" && <Field label="Annullata da" value={`${d.cancelled_by || ""} · ${dateIt(d.cancelled_at)}`} />}
              {d.profiled && <Field label="Profilato da" value={`${d.profiled_by || ""} · ${dateIt(d.profiled_at)}`} />}
            </div>
            <div className="p-4 rounded-xl border border-amber-200 bg-amber-50/60">
              <div className="flex items-center gap-2 mb-3">
                <GraduationCap className="w-4 h-4 text-amber-600" />
                <div className="text-sm font-bold text-slate-800">Crediti Formativi Professionali</div>
                {d.requires_cfp
                  ? <Badge className="bg-emerald-100 text-emerald-800 hover:bg-emerald-100">Richiesti</Badge>
                  : <Badge className="bg-slate-100 text-slate-600 hover:bg-slate-100">Non richiesti</Badge>}
              </div>
              {d.requires_cfp && (
                <div className="grid grid-cols-2 gap-4">
                  <Field label="Profilo professionale" value={d.professional_profile} />
                  <Field label="Provincia dell'ordine" value={d.professional_province} />
                </div>
              )}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
